import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import { App } from "./App.js";
import "./index.css";

/**
 * O service worker, registrado por aqui e não pelo script que o plugin injeta.
 *
 * A diferença é a recarga. Aquele script só registrava: o service worker novo
 * assumia o controle (`skipWaiting` + `clientsClaim`), mas a página já aberta
 * seguia rodando o código antigo até alguém apertar F5. Depois de um deploy,
 * **todo aparelho via a tela anterior uma vez** — e, se a API já tivesse mudado
 * de contrato, essa tela antiga falhava. Foi o que aconteceu quando o login
 * passou a ser por e-mail: o formulário em cache continuava mandando
 * `username`, e a resposta era um erro de validação sem sentido para quem lia.
 *
 * Com `registerType: "autoUpdate"`, omitir `onNeedReload` deixa valer o padrão
 * do plugin, que é `window.location.reload()` assim que a versão nova assume.
 *
 * O custo: quem estiver com a tela aberta na hora de um deploy perde o que
 * estava preenchendo. É pouco perto de operar sobre uma versão que não combina
 * mais com o servidor — e deploy não acontece durante evento.
 */
registerSW({ immediate: true });

const container = document.getElementById("root");
if (!container) throw new Error("Elemento #root não encontrado");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
